import { createSlice } from "@reduxjs/toolkit";
import { TradingState } from "./types";
import { fetchPairs, fetchTradingWallet } from "./trading-thunk";
import { ErrorType } from "@/shared/types";

const initialState: TradingState = {
    pairs: [],
    wallet: {},
    isPairsLoading: false,
    isPairsFirstLoad: true,
    pairsError: null,
    isWalletLoading: false,
    isWalletFirstLoad: true,
    walletError: null
}

const tradingSlice = createSlice({
    name: 'trading',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchPairs.pending, (state) => {
            state.isPairsLoading = true
        })
        .addCase(fetchPairs.fulfilled, (state, action) => {
            state.isPairsLoading = false
            state.isPairsFirstLoad = false
            state.pairs = action.payload
            state.pairsError = null
        })
        .addCase(fetchPairs.rejected, (state, action) => {
            state.isPairsLoading = false
            state.pairsError = action.payload as ErrorType ?? null
        })
        .addCase(fetchTradingWallet.pending, (state) => {
            state.isWalletLoading = true
        })
        .addCase(fetchTradingWallet.fulfilled, (state, action) => {
            state.isWalletFirstLoad = false
            state.isWalletLoading = false
            state.wallet = action.payload
            state.walletError = null
        })
        .addCase(fetchTradingWallet.rejected, (state, action) => {
            state.isWalletLoading = false
            state.walletError = action.payload as ErrorType ?? null
        })
    },
})

export default tradingSlice.reducer